import styled from 'styled-components';

import { Section, Select, Table } from '@appcues/sonar';

export const Wrapper = styled(Section)`
  width: 100%;
  min-height: 232px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Cell = styled(Table.Td)`
  min-width: 142px;
  max-width: 264px;
`;

export const HeaderCell = styled(Table.Th)`
  min-width: 142px;
  max-width: 264px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  padding: var(--spacing-large);
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--spacing-large);
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  display: flex;
  align-items: center;
`;

export const NoResultsMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(var(--table-wrapper-min-height) - 38px);
  flex-direction: column;
  gap: var(--spacing-regular);
  margin-top: var(--spacing-regular);
`;

export const IdentifierSelect = styled(Select)`
  width: 222px;

  & > div {
    width: 100%;
  }
`;

export const NoWrapValueWrapper = styled.div`
  div {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 160px;
  }
`;
